'use client';

import { LoginComponent, SignUpComponent } from '@/components';
import styles from './loginPage.module.scss';
import { useState } from 'react';

type AuthComponent = 1 | 2;

export default function Home() {
  const [currentComponent, setCurrentComponent] = useState<AuthComponent>(1);

  return (
    <section className={`${styles.loginPage}`}>
      {currentComponent === 1 ? (
        <LoginComponent setCurrentComponent={setCurrentComponent} />
      ) : (
        <SignUpComponent />
      )}
    </section>
  );
}
